import React from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDate } from '../../utils/helpers';

// Desktop Dashboard: KPI tiles of a fixed, readable size (they do not stretch
// across a wide screen), then the selected event as a card as wide as its text.
export default function DashboardDesktop({ vm }) {
  const { event, cards, mySide, isMarriage } = vm;
  const navigate = useNavigate();
  const place = [event?.Venue, event?.City].filter(Boolean).join(', ');
  return (
    <div>
      <div className="page-head">
        <h1>Dashboard</h1>
        {/* The side is the signed-in user's own (My Profile) — nothing to pick here. */}
        {isMarriage && mySide && (
          <span className={mySide === 'Groom' ? 'chip male' : 'chip female'}>{mySide} side</span>
        )}
        <div className="spacer" />
        <span className="muted">{event?.EventName || 'Select event'}</span>
      </div>

      <div className="ev-dash-kpis">
        {cards.map((card, index) => (
          <button
            key={index}
            type="button"
            className="kpi-card kpi-link"
            style={{ background: card.g }}
            title={card.to ? `Open ${card.l}` : undefined}
            onClick={() => card.to && navigate(card.to)}
          >
            <div className="n">{card.n}</div>
            <div className="l">{card.l}</div>
          </button>
        ))}
      </div>

      {event && (
        <div className="card card-pad ev-dash-event">
          <strong style={{ fontSize: 15 }}>{event.EventName}</strong>
          <div className="ev-dash-meta">
            <span>{event.EventTypeName || event.EventType}</span>
            <span>📅 {fmtDate(event.EventStartDate)} – {fmtDate(event.EventEndDate)}</span>
            {place && <span>📍 {place}</span>}
          </div>
          {isMarriage && (
            <div className="ev-dash-sides">
              <span className="chip male">Groom: {event.MaleSideName || '-'}</span>
              <span className="chip female">Bride: {event.FemaleSideName || '-'}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
